import * as React from 'react';
export const IcDongleAudio = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9 2H7a3 3 0 00-3 3v2h8V5a3 3 0 00-3-3zM4 19a3 3 0 003 3h2a3 3 0 003-3V9H4v10zM19.9 6.57a1.07 1.07 0 00-.3-.37 1 1 0 00-.43-.2 1 1 0 00-.46 0L14 7.44v2.13l4-1.19V13a2 2 0 00-1.41 3.42c.27.279.619.467 1 .54a2 2 0 002.05-.85A2 2 0 0020 15V7a1 1 0 00-.1-.43z'
      fill='currentColor'
    />
  </svg>
);
